import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

// Vuex.Store 构造器选项
const store = new Vuex.Store({
    state: {
        // 用户信息
        userInfo: localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {},
        // 登录token
        token: localStorage.getItem('token'),
        // token过期标识
        tokenInvalidFlag: false,
        articles: localStorage.getItem('articles') ? JSON.parse(localStorage.getItem('articles')) : [],
    },
    mutations: {
        setUserInfo(state, userInfo) {
            state.userInfo = userInfo
            // 将用户信息存入localStorage
            localStorage.setItem('userInfo', JSON.stringify(userInfo))
        },
        setArticles(state, articles) {
            state.articles = articles
            localStorage.setItem('articles', JSON.stringify(articles))
        },
        setToken(state, token) {
            state.token = token
            // 将token存入localStorage
            localStorage.setItem('token', token)
        },
        logout(state) {
            state.token = ''
            state.userInfo = {}
            // 将用户信息从localStorage中移除
            localStorage.removeItem('userInfo')
            // 将token从localStorage中移除
            localStorage.removeItem('token')
        },
    },
    actions: {},
});

export default store
